import api from "../../services/api";


export default async function getOneMessage(idmsg) {
	
	const { data } = await  api.get(`/Mensaje/getone/${idmsg}`);
	return  data;
}

